export default {
  props: {
    emptyPositionsText: {
      type: String,
      required: true,
    },
  },
}
